import { axiosConsumer } from "./axiosConsumer";

export const contactTicket = async (body): Promise<unknown[]> => {
  const { data } = await axiosConsumer.post(`api/v1/desk-ticket`, body);
  return data;
};

export const getPresignedURL = async (
  fileType: string,
  dealerId: string
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.get(
    `/api/v1/file-upload-url?folderName=desk-tikcet-files&fileType=${fileType}&dealerId=${dealerId}`
  );
  return data;
};
